/** `volunteers.regionId` / primary selected region for Jamaica trip logistics. */
export const JAMAICA_VOLUNTEER_REGION_ID = 4

/**
 * FL Harlem Heights — homeowners exist from pre-app work, but volunteers were not tracked.
 * Exclude from volunteer regional roster multiselect.
 */
export const HARLEM_HEIGHTS_REGION_ID = 1

export const VOLUNTEER_ROSTER_EXCLUDED_REGION_IDS: number[] = [HARLEM_HEIGHTS_REGION_ID]

export function isVolunteerRosterExcludedRegion(
  regionId: string | number,
  label?: string | null
): boolean {
  const id = typeof regionId === 'number' ? regionId : Number(regionId)
  if (Number.isFinite(id) && VOLUNTEER_ROSTER_EXCLUDED_REGION_IDS.includes(id)) {
    return true
  }
  return typeof label === 'string' && /harlem\s*heights/i.test(label)
}
